import React, { useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { MessageSquare, Mail, Phone, FileText, Send, HelpCircle, Book, Video } from 'lucide-react';

const Support = () => {
  const [message, setMessage] = useState('');
  const [subject, setSubject] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Support-Anfrage:', { subject, message });
    alert('Ihre Support-Anfrage wurde gesendet!');
    setSubject('');
    setMessage('');
  };

  const supportOptions = [
    {
      icon: Mail,
      title: 'E-Mail Support',
      description: 'support@autogutachter24.de',
      color: 'blue'
    },
    {
      icon: Phone,
      title: 'Telefon Support',
      description: '+49 30 12345678',
      color: 'green'
    },
    {
      icon: Book,
      title: 'Dokumentation',
      description: 'Handbücher & Guides',
      color: 'purple'
    },
    {
      icon: Video,
      title: 'Video Tutorials',
      description: 'Schritt-für-Schritt Anleitungen',
      color: 'orange'
    }
  ];

  const faqs = [
    {
      question: 'Wie erstelle ich eine neue Akte?',
      answer: 'Klicken Sie auf den "Neue Akte" Button im Header oder navigieren Sie zu Akten > Neue Akte.'
    },
    {
      question: 'Wie kann ich Kundendaten importieren?',
      answer: 'Gehen Sie zu Kunden und nutzen Sie die Upload-Funktion für XML, CSV oder JSON Dateien.'
    },
    {
      question: 'Wo finde ich meine Gutachten?',
      answer: 'Alle Gutachten finden Sie unter dem Menüpunkt "Akten" in der Übersicht.'
    }
  ];

  return (
    <DashboardLayout>
      <div className="space-y-6">
        {/* Header */}
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Support</h1>
          <p className="text-gray-500 mt-1">Wir helfen Ihnen gerne weiter</p>
        </div>

        {/* Support Optionen */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {supportOptions.map((option, index) => {
            const Icon = option.icon;
            const colorClasses = {
              blue: 'bg-blue-100 text-blue-600',
              green: 'bg-green-100 text-green-600',
              purple: 'bg-purple-100 text-purple-600',
              orange: 'bg-orange-100 text-orange-600'
            };
            return (
              <Card key={index} className="hover:shadow-lg transition-shadow cursor-pointer">
                <CardContent className="pt-6">
                  <div className={`w-12 h-12 rounded-lg ${colorClasses[option.color]} flex items-center justify-center mb-4`}>
                    <Icon className="w-6 h-6" />
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-1">{option.title}</h3>
                  <p className="text-sm text-gray-500">{option.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Support Anfrage */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center space-x-2">
                <MessageSquare className="w-5 h-5" />
                <span>Support-Anfrage senden</span>
              </CardTitle>
            </CardHeader>
            <CardContent>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Betreff
                  </label>
                  <Input
                    value={subject}
                    onChange={(e) => setSubject(e.target.value)}
                    placeholder="Worum geht es?"
                    required
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Nachricht
                  </label>
                  <textarea
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    placeholder="Beschreiben Sie Ihr Anliegen..."
                    rows="6"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700">
                  <Send className="w-4 h-4 mr-2" />
                  Anfrage senden
                </Button>
              </form>
            </CardContent>
          </Card>

          {/* FAQ */}
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center space-x-2">
                <HelpCircle className="w-5 h-5" />
                <span>Häufig gestellte Fragen</span>
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                {faqs.map((faq, index) => (
                  <div key={index} className="border-b border-gray-200 pb-4 last:border-0">
                    <h4 className="font-semibold text-gray-900 mb-2">{faq.question}</h4>
                    <p className="text-sm text-gray-600">{faq.answer}</p>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Support;